import React, { useContext, useEffect, useState } from "react";
import Header from "../components/Includes/Header";
import Footer from "../components/Includes/Footer";
import Loader from "../components/Loader/Loader";
import { StoreContext } from "../store/Store";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";

const iconSet = [
  "mdi:graph-bar",
  "mdi:graph-line",
  "mdi:graph-scatter-plot-hexbin",
  "mdi:graph-box-outline",
  "mdi:graph-multiple",
];

const iconColors = ["#87d7d9", "#eeb183", "#f0b1b1", "#93befd", "#bcbaf8"];

const assignIcons = (configs) => {
  const shuffledIcons = [...iconSet].sort(() => 0.5 - Math.random());
  const result = {};
  configs.forEach((config, idx) => {
    result[config.pk_config_id] = {
      icon: shuffledIcons[idx % shuffledIcons.length],
      color: iconColors[idx % iconColors.length],
    };
  });
  return result;
};

const DatabaseConfigs = () => {
  const {
    getDatabaseConfigs,
    databaseConfigs,
    selectSpecificDatabase,
    logout,
    setUserid
  } = useContext(StoreContext);

  const [iconMap, setIconMap] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    const userid = localStorage.getItem("userid");
    if (userid) {
      getDatabaseConfigs(userid);
    }
  }, []);
  
  useEffect(() => {
      if (Array.isArray(databaseConfigs)) {
        const map = assignIcons(databaseConfigs);
        setIconMap(map);
      }
    }, [databaseConfigs]);

  function handleConfig(config_id) {
    selectSpecificDatabase(config_id, navigate);
  }

  function handleLogout() {
    logout();
    setUserid(null)
  }

  const validConfigs = Array.isArray(databaseConfigs) ? databaseConfigs : [];
  const hasConfigs = validConfigs.length > 0;
  const isLoading = databaseConfigs === null || databaseConfigs === undefined;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      className="dbconfigs"
      style={{ minHeight: "100vh", position: "relative" }}
    >
      <Header />
      <div
        style={{
          position: "fixed",
          top: "13px",
          right: "20px",
          backgroundColor: "#000",
          color: "#fff",
          padding: "8px 16px",
          borderRadius: "25px",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "500",
          zIndex: 99999,
        }}
        onClick={handleLogout}
      >
        Logout
      </div>

      <div className="main-wrapper">
        <div
          style={{
            fontSize: "clamp(28px, 4vw, 38px)",
            textAlign: "center",
            marginBottom: "40px",
            fontWeight: "400",
          }}
        >
          Please choose your{" "}
          <span style={{ color: "#3a80c2", fontWeight: "600" }}>Database</span>
        </div>

        {hasConfigs.length === 0 ? (
          <div
            style={{
              fontSize: "18px",
              color: "#666",
              textAlign: "center",
              padding: "60px 20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Icon
              icon="mdi:database-off"
              style={{
                fontSize: "64px",
                marginBottom: "20px",
                color: "#ccc",
              }}
            />
            <div style={{ fontSize: "20px", fontWeight: "500" }}>
              No database configurations found
            </div>
            <div style={{ fontSize: "16px", color: "#999", marginTop: "8px" }}>
              Please contact your administrator to set up database access
            </div>
          </div>
        ) : (
          <div className="databasePcontainer-wrapper">
            <div className="databasePcontainer" >
              {validConfigs.map((item, idx) => {
                const theme = iconMap[item.pk_config_id];
                const gradients = [
                  "linear-gradient(90deg, #dbf4f4 0%, rgb(255, 255, 255) 30%)",
                  "linear-gradient(90deg, rgb(251, 236, 221) 0%, rgb(255, 255, 255) 30%)",
                  "linear-gradient(90deg, rgb(249, 224, 224) 0%, rgb(255, 255, 255) 30%)",
                  "linear-gradient(90deg, rgba(221, 233, 254, 0.9) 0%, rgba(255, 255, 255, 1) 30%)",
                  "linear-gradient(90deg, rgb(223, 223, 252) 0%, rgb(255, 255, 255) 30%)",
                ];
                const gradient = gradients[idx % gradients.length];
                return (
                  <div className="card-wrapper" key={item.pk_config_id || idx}>
                    <div className="card-placeholder" />

                    <div
                      className="modern-card"
                      style={{ background: gradient }}
                      onClick={() => handleConfig(item.pk_config_id)}
                    >
                      <div className="card-left">
                        <div className="card-icon-wrapper">
                          <Icon
                            icon={theme?.icon || "mdi:database-outline"}
                            width="30"
                            height="30"
                            style={{ color: theme?.color || "#3a80c2" }}
                          />
                        </div>
                        <div className="card-text-group">
                          <div className="card-title">
                            {item.config_db_name}
                          </div>
                          <div className="card-subtitle">
                            Created on:{" "}
                            {new Date(item.created_at).toLocaleDateString(
                              "en-GB"
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="card-chevron">
                        <Icon icon="mdi:chevron-right" />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default DatabaseConfigs;
